module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/experience04-9a2bd2f4e4332ec3aaa1d0560fc0883d.svg";